import _axios from '@/utils/request'

// 内容管理-内容列表
export function postContentList (param) {
    return _axios('post', `/ms-shulan-hospital/v1/content/list`, param)
}

//  新增半原创-解析链接
export function postAnalysisUrl (param) {
    return _axios('post', `/ms-shulan-hospital/v1/content/analysis_url`, param)
}

//  新增半原创/新增原创 ---保存
export function postSaveContent (param) {
    return _axios('post', `/ms-shulan-hospital/v1/content/save`, param)
}

//  新增半原创/新增原创 ---保存
export function deleteByContentId (contentId) {
    return _axios('delete', `/ms-shulan-hospital/v1/content/delete/${contentId}`)
}

// 上传文件
export function uploadFileList (file) {
    return _axios(
        'post', '/ms-hoc-material/v3/file/uploadMultipleFile', file
    )
}

// 上传图片
export function uploadImgList (param, file) {
    return _axios('post', `/ms-hoc-video/v1/image/upload?hospitalId=${param.hospitalId}&iuid=${param.iuid}&ImageType=PATIENTCONTENT`, file)
}

//  获取半原创信息
export function getByContentId (contentId) {
    return _axios('get', `/ms-shulan-hospital/v1/content/${contentId}`)
}

//  编辑内容
export function postContentUpdate (param) {
    return _axios('post', `/ms-shulan-hospital/v1/content/update`, param)
}
